// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1mz4w","priceDisplay":"_1oiA9","button":"_1hwpQ"};